/* UTILS */
import {
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  CITY,
  MAILING_ADDRESS,
  ZIPCODE
} from "../constants";
import fieldData from "./fieldData";
import useAppContext from "../../AppContext";
/* COMPONENTS */
import Textfield from "../Textfield";
/* STYLES */
import styles from "./styles.module.scss";

const BuildInput = ({
  id,
  name,
  placeholder,
  rules,
  value,
  onChange,
  withAutofocus = false,
  ...rest
}) => (
  <Textfield
    id={id}
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    rules={rules}
    styles={styles}
    withAutofocus={withAutofocus}
    wrapperClassName={styles.inputWrapper}
    {...rest}
  />
);

const Address = ({ onChange }) => {
  const { profile } = useAppContext();
  const {
    addressLine1 = "",
    addressLine2 = "",
    city = "",
    zipcode = ""
  } = profile[MAILING_ADDRESS] || {};

  return (
    <div className={styles.address}>
      <BuildInput
        {...fieldData[ADDRESS_LINE_1]}
        value={addressLine1}
        onChange={onChange}
      />
      <BuildInput
        {...fieldData[ADDRESS_LINE_2]}
        value={addressLine2}
        onChange={onChange}
      />
      <BuildInput {...fieldData[CITY]} value={city} onChange={onChange} />
      <BuildInput {...fieldData[ZIPCODE]} value={zipcode} onChange={onChange} />
    </div>
  );
};

export default Address;
